export const ADD = 'entities/donation/ADD';
export const ADD_MULTIPLE = 'entities/donation/ADD_MULTIPLE';
export const UPDATE_MULTIPLE = 'entities/donation/UPDATE_MULTIPLE';
export const SET_TOTAL = 'entities/donation/SET_TOTAL';
export const SET_DISPLAYED_DONATION_IDS = 'entities/donation/SET_DISPLAYED_DONATION_IDS';
export const SET_DONATIONS_LOADED = 'entities/donation/SET_DONATIONS_LOADED';
export const UPDATE_DONATION_DESIRED_AMOUNT = 'entities/donation/UPDATE_DONATION_DESIRED_AMOUNT';
